import OFooter from './OFooter'

export default OFooter
